/**
 * If email is empty.
 * 
 * @param email
 * @returns boolean
 */
export const isEmpty = (email) => {
    return '' === email ? true : false;
}

/**
 * Verify if the input is a valid email.
 * 
 * @param email
 * @returns boolean
 * @since 1.0.1
 */
export const isEmail = (email) => {
    const regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

    return regex.test( email );
}

/**
 * Parse the URL
 * 
 * @param name 
 * @returns {string} 
 * @since 1.0.1
 */
export const getParameterByName = (name) => {
    const queryString = window.location.search || window.location.hash.split('?')[1];
    
    if (queryString) {
        const urlParams = new URLSearchParams(queryString);
        const value = urlParams.get(name);

        return value !== null ? value : '';
    }

    return ''
};

export const setCookie = ( name, value, days ) => {
    let expires = "";

    if (days) {
        let date = new Date();
        date.setTime( date.getTime() + ( days*24*60*60*1000 ) );
        expires = "; expires=" + date.toUTCString();
    }

    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

export const getCookie = ( name ) => {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');

    for( var i = 0; i < ca.length; i++ ) {
        var c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length,c.length);
    }

    return null;
}

export const eraseCookie =  ( name ) => {
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}

export const getYoutubeEmbedUrl = (url) => {
    // Pattern to match YouTube URLs
    const pattern = /^(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S*?[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/;
    
    // Check if the URL matches the pattern 
    const matches = url.match(pattern);
    if (matches) {
        const videoId = matches[1];
        // Construct the embed URL
        const embedUrl = `https://www.youtube.com/embed/${videoId}`;
        return embedUrl;
    } else {
        return false; // URL doesn't match the pattern
    }
}

/**
 * Generate random int.
 * @param {*} max 
 * @returns 
 */
export const getRandomInt = (max) => {
    return Math.floor(Math.random() * max);
}

/**
 * Wait for a few second before making a request
 * @param {*} func 
 * @param {*} wait 
 * @returns 
 */
export const debounce = (func, wait) => {
    let timeout;
    return function(...args) {
        const context = this;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), wait);
    };
}

/**
 * Validate URL.
 * 
 * @param {*} url 
 * @returns 
 */
export const validateURL = (url) => {
    // Regular expression to match a URL
    var urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;

    // Test the URL against the regex
    return urlRegex.test(url);
}

// Function to extract the email
export const extractEmail = (link) => {
    // Remove 'mailto:' if it exists
    if (link.startsWith('mailto:')) {
        link = link.replace('mailto:', '');
    }

    // Find the position of the '?' which indicates the start of the query parameters
    var queryStart = link.indexOf('?');

    // If there is no '?', the whole string is the email
    if (queryStart === -1) {
        return link;
    }

    // Otherwise, extract the part before the '?' as the email
    return link.substring(0, queryStart);
}